import React from 'react';

import * as S from './styles';
import { Images } from '../../themes';

export default function Footer() {
  return (
    <S.Main>
      <S.RightsReserved>
        <S.RightsReservedText>All rights reserved.</S.RightsReservedText>
        <S.RightsReservedText>
          A Fast Track Ventures Company
        </S.RightsReservedText>
        <S.RightsReservedLinks>
          <S.RightsReservedLink href="/terms#privacy-policy">
            Privacy Policy
          </S.RightsReservedLink>
          <S.RightsReservedSeparator>|</S.RightsReservedSeparator>
          <S.RightsReservedLink href="/terms">Terms</S.RightsReservedLink>
        </S.RightsReservedLinks>
      </S.RightsReserved>

      <S.InvilliaContainer>
        <S.Content>
          <S.InvilliaApps src={Images.branding.invilliaApps} />
          <S.Year>{new Date().getFullYear()}</S.Year>
        </S.Content>
        <S.FooterText>Global Growth Framework &reg;</S.FooterText>
      </S.InvilliaContainer>

      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://invillia.com/"
        style={{ display: 'flex', textDecoration: 'none' }}
      >
        <S.MadeBy>made by</S.MadeBy>
        <S.InvilliaLogo src={Images.branding.invilliaWhite} />
      </a>
    </S.Main>
  );
}
